import styled from 'styled-components';
import theme from '../../theme/theme';

export const Label = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
`;

export const Input = styled.input`
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 14px;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
`;

export const Th = styled.th`
    text-align: left;
    padding: 10px;
    border-bottom: 1px solid #eee;
    background: #fafafa;
`;

export const Td = styled.td`
    padding: 10px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: top;
`;

export const TabsBar = styled.div`
    display: flex;
    gap: 8px;
    border-bottom: 1px solid #eee;
    margin-bottom: 12px;
`;

export const TabButton = styled.button<{ $active?: boolean }>`
    background: ${({$active}) => ($active ? theme.palette.primary.main : 'transparent')};
    color: ${({$active}) => ($active ? '#fff' : '#333')};
    border: 1px solid ${({$active}) => ($active ? theme.palette.primary.main : '#ddd')};
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
`;

export const LogViewer = styled.div`
    background: #0f172a;
    color: #e5e7eb;
    border: 1px solid #1f2937;
    border-radius: 8px;
    padding: 12px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace;
    font-size: 12px;
    line-height: 1.6;
    max-height: 60vh;
    overflow: auto;
    white-space: pre-wrap;
`;

export const LogLine = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 12px;
`;

export const LineNo = styled.span`
    color: #9ca3af;
    user-select: none;
`;

export const Level = styled.span<{ $level?: 'ERROR' | 'WARN' | 'INFO' | 'DEBUG' }>`
    color: ${({$level}) => {
        switch ($level) {
            case 'ERROR':
                return '#fecaca';
            case 'WARN':
                return '#fde68a';
            case 'INFO':
                return '#bae6fd';
            case 'DEBUG':
                return '#c7d2fe';
            default:
                return 'inherit';
        }
    }};
`;
